module.exports = __webpack_public_path__ + "static/media/background.60f5c199.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background.png
// module id = 661
// module chunks = 0